/**
 * @file text.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene funciones para manipular texto
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-27
 * @author Correcta
 * @author Daniel Sentamans
 * @copyright © Correcta
 * @license Private
 * */

export const capitalize = (text: string) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const uncapitalize = (text: string) => {
  if (!text) return "";
  return text.charAt(0).toLowerCase() + text.slice(1);
};

export const trimText = (text?: string) => text?.trim() || "";

export const truncateText = (text: string, maxLength: number) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

export const getTooltipText = (
  text: string | undefined,
  triggerLength: number,
  maxLength: number,
) => {
  const normalizedText = trimText(text);
  if (normalizedText.length <= triggerLength) return "";
  return truncateText(normalizedText, maxLength);
};
